import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';
import { SearchExternalSearchCondition, SearchExternalResultValue } from 'app/area/case/types-store';

export const api = {
  searchExternalProvider: async (caseDraftId: number, domainId: number, searchParameters: SearchExternalSearchCondition[]):
    Promise<SearchExternalResultValue[][]> => {
    const response = await new RemoteData(`${endpoint.draft}/${caseDraftId}/field/${domainId}/externalData/search`)
      .resource<any>()
      .create({ conditions: searchParameters }, false);
    
    const obj = await response.json();
    return obj.data.items;
  }
};
